import React from 'react';

const items = [
  '📅 Nunca Mais Esqueça um Cliente',
  '🔔 Lembrete no Seu WhatsApp',
  '📈 Mais Faturamento Recorrente',
  '⚙️ Cálculo Automático',
  '❄️ Empresas de Ar-Condicionado',
  '💰 Receita que Você Já Tem',
  '✅ Você no Controle Total',
  '🚀 Simples e Rápido',
];

const MarqueeSection: React.FC = () => {
  const doubled = [...items, ...items];

  return (
    <div className="bg-navy-dark border-y border-white/8 py-5 overflow-hidden">
      <div className="marquee-track">
        {doubled.map((item, i) => (
          <React.Fragment key={i}>
            <span className="text-white/50 text-sm font-medium tracking-wide whitespace-nowrap px-2">
              {item}
            </span>
            <span className="text-cyan/40 mx-4">·</span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default MarqueeSection;